export const createTimer = (TIMEOUT: number, cb: () => void): NodeJS.Timer =>
  setTimeout(cb, TIMEOUT)

export type Delay = undefined | number | number[]

export const getDelay = (delay: Delay, idx: number): number => {
  if (!delay) return 0

  if (Array.isArray(delay)) {
    return delay[idx] || 0
  }

  return delay
}
